var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"forbidden"},[_c('p',{staticClass:"forbidden-p"},[_vm._v(_vm._s(_vm.$t("youdonothaveaccess")))]),_c('button',{staticClass:"forbidden-b",on:{"click":_vm.goToCabinet}},[_vm._v(" "+_vm._s(_vm.$t("backToHome"))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }